module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Meeting has ended","description":"The organizer has ended this video interview. Thank you for your time.","action":"Go to Huntica"}}')
  delete Component.options._Ctor
}
